var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.999,
    height: 72,
    viewBox: "0 0 71.999 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    width: 71.999,
    height: 72,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    d: "M36,72A36,36,0,1,1,72,36,36.04,36.04,0,0,1,36,72M36,4.564A31.436,31.436,0,1,0,67.435,36,31.472,31.472,0,0,0,36,4.564",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    d: "M35.524,32.057V21.372H32.672V32h2.4a1.866,1.866,0,0,1,.451.06",
    transform: "translate(-14.034 -9.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    d: "M32.68,60.109V52.374H29.661l-2.343,8.62,1.524,3.711,8.2,5.47,1.47-7.832Z",
    transform: "translate(-11.734 -22.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    d: "M35.654,45.591V42.323A1.328,1.328,0,0,0,34.328,41H30.936v5.92h3.392a1.328,1.328,0,0,0,1.326-1.326",
    transform: "translate(-13.288 -17.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    d: "M63.919,39.61c-1.095-6.072-7.045-6.15-7.111-6.15H55.6c-.067,0-6.016.078-7.111,6.15a2.226,2.226,0,0,0-1.45,2.082v2.616a2.236,2.236,0,0,0,2.233,2.233h1.192l.308,1.7a5.564,5.564,0,0,0,10.863,0l.308-1.7h1.192a2.236,2.236,0,0,0,2.233-2.233V41.692a2.227,2.227,0,0,0-1.451-2.082M56.808,34.7H55.6a6.055,6.055,0,0,0-5.7,4.763h-.634c-.059,0-.114.013-.171.018a6.7,6.7,0,0,1,6.5-5.449h1.206a6.7,6.7,0,0,1,6.5,5.449c-.058,0-.113-.018-.172-.018h-.633a6.055,6.055,0,0,0-5.7-4.763",
    transform: "translate(-20.205 -14.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    d: "M48.643,68.752l-2.622.445L43.66,82.929v1.278h4.983Z",
    transform: "translate(-18.753 -29.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    d: "M78.8,84.207V82.929L76.439,69.2l-2.622-.445V84.207Z",
    transform: "translate(-31.707 -29.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    d: "M55.108,85.551V83.84h4.043V68.094l-1.161-.2-3.237,3.47L51.515,67.9l-1.161.2V83.84H54.4v1.711H43.66v5.906H52.44l2.313-2.091,2.313,2.091h8.781V85.551Z",
    transform: "translate(-18.753 -29.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    d: "M91.391,32V21.372H88.539V32.057A1.9,1.9,0,0,1,88.99,32Z",
    transform: "translate(-38.03 -9.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    d: "M88.121,52.374H85.1v7.734L79.27,62.344l1.47,7.832,8.2-5.47,1.523-3.711Z",
    transform: "translate(-34.049 -22.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    d: "M87,42.323v3.268a1.328,1.328,0,0,0,1.326,1.326h3.392V41H88.33A1.328,1.328,0,0,0,87,42.323",
    transform: "translate(-37.371 -17.61)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundServices);
export default __webpack_public_path__ + "static/media/ground-services.ba8a9fbe85c549edd2b5e8ee3bfdff7e.svg";
export { ForwardRef as ReactComponent };